import { render } from "./nav.vue?vue&type=template&id=5200ff4e&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"

import "./nav.vue?vue&type=style&index=0&id=5200ff4e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5200ff4e"

export default script